<span class="fs-block">{{ value | formatCurrency : digitsToTrim: unitType: decimalPlaces }}</span>
